import { SubClauseWithCompoundExpression } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isObjectRecord } from "./isObjectRecord";
import { isWhereClauseCompoundExpression } from "./isWhereClauseCompoundExpression";

/**
 * Type guard to check if a value is a SubClauseWithCompoundExpression.
 *
 * @param obj - The value to check
 * @returns True if the value is a SubClauseWithCompoundExpression
 */
export const isSubClauseWithCompoundExpression = (
  obj: unknown,
): obj is SubClauseWithCompoundExpression => {
  if (!isObjectRecord(obj)) return false;
  const objectRecord = obj;
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  // Check id is a non-blank string
  if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;

  // Check subClauseId is "" (empty string for non-referenced clauses)
  if (objectRecord.subClauseId !== "") return false;

  // Must have a valid compoundExpression
  if (!isWhereClauseCompoundExpression(objectRecord.compoundExpression)) return false;

  // Must not have condition property
  if (objectRecord.condition !== undefined) return false;

  return true;
};
